import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=05ac85b2&scoped=true"
import script from "./ReportList.vue?vue&type=script&lang=js"
export * from "./ReportList.vue?vue&type=script&lang=js"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=05ac85b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac85b2",
  null
  
)

export default component.exports